"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Sep 21 2018
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * DataPairingStatsDTOConverter
 *
 * @author RV
 */


var DataPairingProductRowDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(DataPairingProductRowDTOConverter, _DataObjectConverter_);

  function DataPairingProductRowDTOConverter() {
    _classCallCheck(this, DataPairingProductRowDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(DataPairingProductRowDTOConverter).apply(this, arguments));
  }

  return DataPairingProductRowDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.DataPairingProductRowDTOConverter = DataPairingProductRowDTOConverter;